import React from "react";
import { Box, Typography, Button, Grid, useMediaQuery } from "@material-ui/core";

const DownloadLanding = () => {
  const isMobile = useMediaQuery("(max-width:768px)");

  const downloadOptions = [
    {
      type: "badge",
      icon: "https://frontend.assets.tangelogames.app/skills/landing/icons/download-on-the-app-store.svg",
      link: "https://mundijuegosdineroreal.onelink.me/zmzo/r01tkx1t",
    },
    {
      type: "custom",
      icon: "https://frontend.assets.tangelogames.app/skills/landing/icons/android.png",
      text: "Download APK",
      link: "https://frontend.assets.tangelogames.app/skills/landing/builds/android/mundigames-cash-4.1.5.apk",
    },
    // {
    //   type: "custom",
    //   icon: "https://frontend.assets.tangelogames.app/skills/landing/icons/huawei.webp",
    //   text: "AppGallery",
    //   link: "https://appgallery.huawei.com/#/app/CXXXXXXX",
    // },
    // {
    //   type: "custom",
    //   icon: "https://frontend.assets.tangelogames.app/skills/landing/icons/samsung.png",
    //   text: "Galaxy Store",
    //   link: "#",
    // },
    {
      type: "custom",
      icon: "https://frontend.assets.tangelogames.app/skills/landing/icons/webgl.png",
      text: "Play Now",
      link: "https://landing.sgs.red/play",
    },
  ];

  return (
      <Box
          minHeight="100vh"
          bgcolor="#111"
          color="#fff"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          p={4}
      >
        <Typography variant="h4" align="center" gutterBottom>
          Win Real Money Playing Mundigames Cash
        </Typography>

        <Typography variant="body1" align="center" gutterBottom>
          Download the app or play online now. Available for iOS, Android and WebGL.
        </Typography>

        <Grid container spacing={2} justifyContent="center" alignItems="center">
          {downloadOptions.map((opt, index) => (
              <Grid item key={index}>
                {opt.type === "badge" ? (
                    <a href={opt.link} style={{ display: "inline-block", width: 150, height: 48 }}>
                      <img
                          src={opt.icon}
                          alt="App Store"
                          style={{ width: "100%", height: "100%", objectFit: "contain" }}
                      />
                    </a>
                ) : (
                    <Button
                        variant="outlined"
                        href={opt.link}
                        startIcon={<img src={opt.icon} alt={opt.text} style={{ height: 24, width: 24 }} />}
                        style={{
                          width: 150,
                          height: 48,
                          color: "#fff",
                          borderColor: "#fff",
                          backgroundColor: "#000",
                          textTransform: "none",
                          borderRadius: 12,
                        }}
                    >
                      {opt.text}
                    </Button>
                )}
              </Grid>
          ))}
        </Grid>

        {!isMobile && (
            <Box mt={6} textAlign="center">
              <Typography variant="body2" gutterBottom>
                Scan to play on mobile:
              </Typography>
              <img
                  src="https://frontend.assets.tangelogames.app/skills/landing/icons/qr.png"
                  alt="QR Code"
                  style={{ width: 160, height: 160 }}
              />
            </Box>
        )}
      </Box>
  );
};

export default DownloadLanding;
